import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const MINOR_DEPENDENTS_QUERY_KEY = "MINOR_DEPENDENTS_QUERY_KEY";

export const useMinorDependentsQuery = (careproviderUserId) => {
  return useQuery({
    queryKey: [MINOR_DEPENDENTS_QUERY_KEY, careproviderUserId],
    retry: false,
    queryFn: listMinorDependents.bind(this, careproviderUserId),
    placeholderData: [],
    enabled: !!careproviderUserId,
  });
};

const listMinorDependents = async (careproviderUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "careprovidersapi",
    path: "/minor-dependents/" + careproviderUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
